import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../../../shared/breadcrumbs/Breadcrumbs';
import '../../Technical.css';

class GetCategoryCount extends Component {
    render() {
        return (
            <div className="technical-main">
                <Breadcrumbs />
                <div className="technical-content">
                    <h1 className="main-heading">
                        Gallery API
                </h1>
                    <div>
                        <h2 className="main-subheading">
                            pcs.get_category_count</h2>
                        <div className="technical-main-content">
                            <p>
                                Returns the count of categories available to a Subscriber / Product combination.
                                This total is regardless of paging.
                        </p>
                            <div>
                                <h3>
                                    Arguments</h3>
                                <ul>
                                    <li><b>api_key</b> (Required)
                                    <p>
                                            A valid API key that must be obtained from Thales representing a subscriber/product
                                        combination. This will be the product handover key.</p>
                                    </li>
                                    <li><b>method</b> (Required)
                                    <p>
                                            pcs.get_category_count</p>
                                    </li>
                                </ul>
                                <br />
                            </div>
                            <div>
                                <h3>
                                    Example response XML payload</h3>
                                <pre>
                                    &lt;Categories count=”100” /&gt;
                                </pre>
                                <br />
                            </div>
                            <div>
                                <h3>
                                    Error codes</h3>
                                <ul>
                                    <li><b>-1 (General error)</b>
                                        <p>
                                            An internal error ocurred on the server. This is not dependent on the specific method
                                        or parameters passed. If the error persists, contact Thales.</p>
                                    </li>
                                    <li><b>1 (Invalid api_key)</b>
                                        <p>
                                            The <em>api_key</em> passed is not valid or is disabled. Check the key to make sure
                                        it is correct. If so, contact Thales.</p>
                                    </li>
                                    <li><b>2 (Invalid method)</b>
                                        <p>
                                            The method you attempted to call is invalid. Check the <em>method</em> parameter.</p>
                                    </li>
                                    <li><b>3 (No method specified)</b>
                                        <p>
                                            The required <em>method</em> parameter was not informed.</p>
                                    </li>
                                </ul>
                                <br />
                            </div>
                        </div>
                        <div className="document-content-back">
                            <Link className="document-content-link" to='/technical/galleryapi'>Back</Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default GetCategoryCount;